function stableStringify(value) {
  if (value === null || typeof value !== 'object') return JSON.stringify(value);
  if (Array.isArray(value)) return `[${value.map((item) => stableStringify(item)).join(',')}]`;
  const keys = Object.keys(value).sort();
  return `{${keys.map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`;
}

export function draftsMatch(left, right) {
  return stableStringify(left ?? null) === stableStringify(right ?? null);
}

export function newerDraftUi(left, right) {
  if (!left || typeof left !== 'object') return right && typeof right === 'object' ? right : null;
  if (!right || typeof right !== 'object') return left;
  return (Number(left.at) || 0) >= (Number(right.at) || 0) ? left : right;
}

function sameDeviceCopy(local, remote) {
  const sameStamp = !!(local?.serverUpdatedAt && remote?.updated_at && local.serverUpdatedAt === remote.updated_at);
  if (sameStamp) return true;
  return draftsMatch(local?.data, remote?.data);
}

/**
 * Décide s'il faut reprendre un brouillon sans demander.
 * On ne demande que si ce téléphone n'a jamais vu le brouillon,
 * ou si le serveur a divergé pendant que cet appareil était au repos.
 */
export function chooseDraftAction(local, remote) {
  const ui = local?.ui || null;
  if (local?.pending || local?.pendingSubmit) {
    return { action: 'sync' };
  }
  if (local?.data && !(remote && remote.exists)) {
    return {
      action: 'restore',
      data: local.data,
      ui,
      message: 'Brouillon de cet appareil',
      conflictKeys: local.conflictKeys || [],
      updatedAt: local.serverUpdatedAt || null,
    };
  }
  if (remote?.exists && remote.data) {
    if (local?.data && sameDeviceCopy(local, remote)) {
      return {
        action: 'restore',
        data: local.data,
        ui,
        message: 'Brouillon repris',
        conflictKeys: local.conflictKeys || [],
        updatedAt: remote.updated_at || local.serverUpdatedAt || null,
      };
    }
    if (local?.data) {
      return {
        action: 'confirm-server',
        data: remote.data,
        ui,
        updatedAt: remote.updated_at || null,
        reason: 'diverged',
      };
    }
    return {
      action: 'confirm-server',
      data: remote.data,
      ui: null,
      updatedAt: remote.updated_at || null,
      reason: 'unknown-device',
    };
  }
  return { action: 'none' };
}
